// extracted by mini-css-extract-plugin
export default {"quickSearchToolbar":"QuickSearchToolbar_quickSearchToolbar__E3vKu","root":"QuickSearchToolbar_root__Effqk"};